import { Injectable } from "@angular/core";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({ providedIn: "root" })
export class PdfEngineService {
  create(
    doc: any,
    action: "download" | "print" = "download",
    fileName = "file.pdf",
  ) {
    const pdf = pdfMake.createPdf(doc);

    action === "print" ? pdf.print() : pdf.download(fileName);
  }
}
